<template>
    <div>

        <b-card v-if="!editar">
            <div>
                <b-button-group size="sm" class="pull-right">
                    <b-button 
                        size="sm" 
                        :variant="bloque.visible ? 'outline-success' : 'outline-secondary'"
                        @click="cambiaVisible(bloque._id)">
                        <i :class="bloque.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                    </b-button>
                    <b-button 
                        v-if="puedeModificar"
                        variant="outline-secondary"
                        v-b-tooltip.hover title="Modificar"
                        @click="modificaModal()"
                        >
                        <i class="fa fa-pencil fa-lg"></i>
                    </b-button>
                    <b-button 
                        v-if="puedeEliminar"
                        variant="outline-secondary"
                        @click="eliminar()"
                        v-b-tooltip.hover 
                        title="Eliminar">
                        <i class="fa fa-trash fa-lg"></i>
                    </b-button>
                </b-button-group>
            </div>
            <div v-html="bloque.texto" />
        </b-card>

        <!--  ========================== EDITAR MENU ================================ -->

        <b-card-body v-if="editar">
            <b-row>
                <b-col sm="12" lg="12">
                    <vue-ckeditor 
                        v-model="bloqueTmp.texto" 
                        :config="editorConfig" 
                    />
                </b-col>
                <b-col sm="12" lg="12">&nbsp;</b-col>
                <b-col sm="6" lg="6">
                    <b-button 
                        variant="secondary"
                        @click="editar=false">
                        Cancelar
                    </b-button>
                </b-col>
                <b-col sm="6" lg="6" class="text-right">
                    <b-button 
                        variant="primary"
                        @click="modificar()">
                        Guardar
                    </b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

import VueCkeditor from 'vue-ckeditor2';
    
export default {
  name: 'ItemBloque',
  props:["bloque","tipoItem"],
  components: {
      VueCkeditor
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeModificar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 135) >= 0 )
            return true;
        else
            return false;
    },
    puedeEliminar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 136) >= 0 )
            return true;
        else
            return false;
    },
    headerImg(){
        if( !this.header.imagen.path )
            return "/img/lupa.png";
        else
            return this.httpURL+'/'+this.header.imagen.path;
    }
  },
  watch: {
      headerUp(){
          this.header = this.headerUp;
      },
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        id: this.$route.params.id,
        bloqueTmp: {},
        editar: false,
        editorConfig: {
            toolbar: [
                ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript','Image'],
                ['NumberedList','BulletedList','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','TextColor','BGColor'],
                ['Link','Table','SpecialChar','Styles','Format','Font','FontSize'],
                ['Cut','Copy','Paste','PasteText','PasteFromWord','Undo','Redo']
            ],
            height: 300
        }
    }
  },
  methods: {
    modificaModal(){
        this.bloqueTmp = this.$_.clone(this.bloque);
        this.editar = true;
    },
    modificar(){
        this.$emit('enviandoStart');
        axios.put(this.httpURL+'/transparencia/normatividad/bloque/'+this.tipoItem+'/'+this.id,
              {
                id:this.bloque._id,
                texto:this.bloqueTmp.texto
              },
              {headers: {token:this.sessionToken}})
          .then(res => {
              this.bloque.texto = this.bloqueTmp.texto;
              this.$emit('enviandoStop');
              this.editar = false;
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
          })
          .catch(error => {
              this.$emit('enviandoStop');
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
    },
    eliminar(){
        swal({
                icon: 'info',
                title: 'Área protegida',
                text: 'Esta acción requiere de tu contraseña:',
                content: {
                element: "input",
                attributes: {
                placeholder: "Ingrese...",
                type: "password",
            }
            },
                closeOnClickOutside: true,
                button: {
                text: "Confirmar",
                closeModal: false,
            },
        })
        .then(password => {
            if (!password){
                swal.close();
            }else{
                this.$emit('enviandoStart');
                axios.delete(this.httpURL+'/transparencia/normatividad/bloque/'+this.tipoItem+'/'+this.id+'/'+this.bloque._id,
                        {data:{password},headers: {token:this.sessionToken}})
                    .then(res => {
                        swal.close();
                        this.$emit('enviandoStop');
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                        this.$emit('eliminar');
                    })
                    .catch(error => {
                        this.$emit('enviandoStop');
                        swal.close();
                        if(error.response){
                            this.error = error.response.data.mensaje;
                            //console.log(error.response);
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                        }
                    });
            }
        });
    },
    cambiaVisible(id){
      this.enviando = true;
      axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/bloque/'+id+'/visible',
              {},
              {headers: {token:this.sessionToken}})
          .then(res => {
              //this.docs.splice(index,1);
              //this.enviando = false;
              if( res.data.ok ){
                  this.$emit('bloqueVisible',{id,visible: res.data.visible});
                  this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                      text: 'Cambios guardados correctamente' });
              }
          })
          .catch(error => {
              //console.log(error.response);
              //this.enviando = false;
            if(error.response){
                this.error = error.response.data.mensaje;
                //console.log(error.response);
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: 'No se pudo establecer una conexión al servidor.' });
            }
          });

    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	
	top: 50%;
	display: block;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
